var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceParking01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_11-park_00000029764520116940985240000018204446463448722831_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,16C123.5,16,16,123.5,16,256s107.5,240,240,240s240-107.5,240-240C495.9,123.5,388.5,16.1,256,16z M256,456 c-110.5,0-200-89.5-200-200S145.5,56,256,56s200,89.5,200,200C455.9,366.4,366.4,455.9,256,456z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,156.1h-70.2c-11,0-20,9-20,20v200.3h40.3v-80.6h48.9c40,0,72.6-33.2,70.8-73.2 C354.5,185.6,323.9,156.1,286.4,156.1L286.4,156.1z M285,256.4h-49.4v-60h50c17.3,0,31.2,14.7,29.9,32.2 C314.4,244.5,300.8,256.4,285,256.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceParking01);
export default __webpack_public_path__ + "static/media/deviceParking-01.b9bb5df6bb65e970bf7043c53cf5ce3e.svg";
export { ForwardRef as ReactComponent };